import { Cradle } from "services/serviceContainer.types";
import { IApplicationAIVetting, IApplicationAIVettingResult } from "models/ApplicationAIVetting.model";
import { IApplicationAIVettingService } from "services/application-ai-vetting/ApplicationAIVettingService.type";
import get from "lodash/get";
import toString from "lodash/toString";

export class ApplicationAIVettingService implements IApplicationAIVettingService {
  private readonly apiClient: Cradle["apiClient"];
  private readonly i18n: Cradle["i18n"];

  constructor(args: Pick<Cradle, "apiClient" | "i18n">) {
    this.apiClient = args.apiClient;
    this.i18n = args.i18n;
  }
  public async fetchAIVettingResponse(applicationId: number): Promise<IApplicationAIVetting> {
    const response = await this.apiClient.protectedApi.get(`/user/applications/${applicationId}/ai-vetting-validation`);
    return this.parseAIVettingResponse(response.data);
  }

  private parseAIVettingResponse(json: any): IApplicationAIVetting {
    const results = this.parseAIVettingResults(get(json, "validationResults"));
    const aiResponse: IApplicationAIVetting = {
      isCompleted: Boolean(get(json, "isCompleted")),
      validationResults: results,
    };
    return aiResponse;
  }

  private parseAIVettingResults(json: any): IApplicationAIVettingResult[] {
    const results: IApplicationAIVettingResult[] = [];
    if (!Array.isArray(json)) {
      return results;
    }
    for (const item of json) {
      results.push({
        ruleName: toString(get(item, "ruleName")),
        ruleResult: toString(get(item, "ruleResult")),
      });
    }
    return results;
  }
}
